import { render, staticRenderFns } from "./import-products.modal.vue?vue&type=template&id=ea4dfa36&scoped=true&"
import script from "./import-products.modal.vue?vue&type=script&lang=js&"
export * from "./import-products.modal.vue?vue&type=script&lang=js&"
import style0 from "./import-products.modal.vue?vue&type=style&index=0&id=ea4dfa36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4dfa36",
  null
  
)

export default component.exports